import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

import chevronLeft from '../../assets/icons/chevron-left.png';

const PaginationPreviousSmall = ({clang, setPreviousPage}) => {
    return (
        <button type="button" className="pagination__previous--small" onClick={() => setPreviousPage()} title={lang[clang].pagination.previous_title}>
            <img className="pagination__previous--small__img" src={chevronLeft} alt="" />
        </button>
    );
};

PaginationPreviousSmall.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(PaginationPreviousSmall);



// WEBPACK FOOTER //
// ./src/components/pagination/PaginationPreviousSmall.js